export const newTabName = [
  { name: 'ALL', key: 'all', active: true },
  { name: 'ANNOUNCEMENTS', key: 'announcements', active: false },
  { name: 'GAME UPDATES', key: 'game_updates', active: false },
  { name: 'EVENTS', key: 'events', active: false },
  { name: 'MEDIA', key: 'media', active: false }
];
export const TAB_NAME_TYPE = {
  0: 'ALL',
  1: 'ANNOUNCEMENTS',
  2: 'GAME_UPDATES',
  3: 'EVENTS',
  4: 'MEDIA'
}
